import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { H4, NamedLink } from '../../components';
import { getAverageRating } from '../../util/reviews';

import css from './ListingPage.module.css';

const SectionReviews = props => {
  const { reviews, fetchReviewsError, authorId } = props;
  const reviewsError = fetchReviewsError ? (
    <p className={css.error}>
      <FormattedMessage id="ListingPage.reviewsLoadingFailed" />
    </p>
  ) : null;

  return (
    <div className={css.sectionReviews}>
      <NamedLink
        name="ProfilePage"
        params={{ id: authorId }}
        to={{ hash: '#reviews' }}
        className={css.reviewsLink}
      >
        <H4 as="h2" className={css.reviewsTitle}>
          <FormattedMessage id="ListingPage.reviewsTitle" values={{ count: reviews.length }} />
        </H4>
      </NamedLink>
      {reviewsError}
    </div>
  );
};

export default SectionReviews;
